import { ReactElement } from "react";
import styles from "./LoadMoreIndicator.module.less";
import {
	BusyIndicator,
	Intersection
} from "client/Components";

export type LoadMoreIndicatorProps = {
	isLoadingData: boolean;
} & (
	| {
		hasMoreItems: true;
		onRequestMoreItems(): void;
	}
	| {
		hasMoreItems: false;
		onRequestMoreItems?(): void;
	}
);

export const LoadMoreIndicator = (props: LoadMoreIndicatorProps): ReactElement | null => {
	const {
		isLoadingData,
		hasMoreItems,
		onRequestMoreItems
	} = props;

	const renderContent = (): ReactElement | null => {
		if (isLoadingData) {
			return <BusyIndicator/>;
		}

		if (hasMoreItems) {
			return (
				<Intersection
					onEnter={onRequestMoreItems}
					runOnce
				/>
			);
		}

		return null;
	};

	const content: ReactElement | null = renderContent();

	if (content === null) {
		return null;
	}

	return (
		<div className={styles.root}>
			{content}
		</div>
	);
};

LoadMoreIndicator.displayName = "LoadMoreIndicator";